module.exports = __webpack_public_path__ + "img/password.4d91314d.svg";